
// src/web/components/diary-likes.jsx

import React from 'react'
import ReactDOM from 'react-dom'
import { themr } from 'react-css-themr'
import { translate } from 'react-i18next'
import diaryTheme from './themes/diary.css'
import Tooltip from 'react-toolbox/lib/tooltip'
import {
  Button,
} from 'react-toolbox/lib/button'
import Avatar from 'react-toolbox/lib/avatar'
import {
  FontIcon,
} from 'react-toolbox/lib/font_icon'
import emoji from '../../native/assets/emoji'

const TooltipButton = Tooltip(Button)

@themr('Diary', diaryTheme)
class DiaryLikes extends React.Component {
  render() {
    const {
      t,
      likes,
      user,
      likes_count,
      myself,
      theme,
      showReaders,
      comment_id,
      likeConfig,
    } = this.props

    //issues/5432
    const count = typeof likes_count != 'undefined' ? likes_count : likes.length

    /* 同じlike_typeが配列内にある場合は除外する */
    const likesArray = likes && likes.reduce((prev, current) => {
      if(!prev.some((e) => e.like_type === current.like_type)) {
        prev.push(current)
      }
      return prev
    }, [])

    if (!likes || likes.length == 0)
      return null

    let tooltip = likes.map((like)=>
          <div key={like.like_id}>
            <Avatar image={like.user.icon_image.thumb_url} theme={theme} />
            &nbsp;
            {like.user.name} &nbsp;
            {<img style={{ height: 16, width: 16 }} src={likeConfig && emoji[likeConfig[like.like_type].icon.replace('\\u','')]} />}
          </div>)
    
    if (likes_count && likes_count > likes.length)
      tooltip.push(<div key="count">...{t('label:他n人', { n: likes_count - likes.length })}</div>)

    return (
      <TooltipButton neutral={false} ripple={false}
        theme={theme}
        className="touchable"
        tooltipPosition="vertical"
              tooltip={tooltip}
              onClick={() => comment_id ? showReaders({comment_id: comment_id, types: 'likes'}) : showReaders({types: 'likes'})}>
      {likesArray.length > 3 ?
        likesArray.slice(likesArray.length - 3, likesArray.length).map((like) => <img style={{ height: 16, width: 16 }} src={likeConfig && emoji[likeConfig[like.like_type].icon.replace('\\u','')]} />) :
        likesArray.slice(0, 3).map((like) => <img style={{ height: 16, width: 16 }} src={likeConfig && emoji[likeConfig[like.like_type].icon.replace('\\u','')]} />)}
      &nbsp;
      {count && t('label:n', { n: count })}
    </TooltipButton>)
  }
}

export default translate()(DiaryLikes)



// WEBPACK FOOTER //
// ./src/web/components/diary-likes.jsx